/* eslint-disable import/no-unresolved */
/* eslint-disable react/no-array-index-key */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */

import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { ApplicationState } from 'store';
import { PanelState } from 'store/modules/panel_store/types';
import { ProfileState } from 'store/modules/profile_store/types';
import Representantes from 'assets/images/banners/banner_representantes.png';
import Compliance from 'assets/images/banners/banner-Banner-Compliance-2026-licitacao-14133.png';
import Il from 'assets/images/banners/banner-agenda-de-cursos-instituto-licitar-licitacao-14133.png';
import Academy from 'assets/images/banners/conlicitacao_academy.png';
import ConlicitaSeg from 'assets/images/banners/banner-conlicitaseg.png';
import BannerRoboLances from 'assets/images/banner-robo-de-lances-comprasgov.png';
import BannerNewRoboLances from 'assets/images/banner-novo-robo-lances.jpg';
import BannerDrlicitaNewPanel from 'components/atoms/banner_drlicita_new_panel';
import Banner from 'components/atoms/banner';

import { Container } from './styles';

const BannerSlideNewPanel = () => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [autoSlide, setAutoSlide] = useState<NodeJS.Timeout | null>(null);
  const { panel } = useSelector<ApplicationState, PanelState>((state) => state.session.panel);
  const { profile } = useSelector<ApplicationState, ProfileState>((state) => state.storage.profile);

  const drLicitaBanner = panel?.dr_licita_access ? [<BannerDrlicitaNewPanel />] : [];

  const conlicitaseg = (
    <Banner
      linkUrl="/conlicitaseg"
      imageUrl={ConlicitaSeg}
      alt="ConlicitaSeg - Seguro-garantia para licitações"
    />
  );

  const defaultIl = (
    <Banner
      linkUrl="https://institutolicitar.com.br/cursos"
      imageUrl={Il}
      alt="Instituto Licitar"
    />
  );

  const compliance = (
    <Banner
      linkUrl="https://api.whatsapp.com/send/?phone=551137899105&text=Ol%C3%A1%21+Vim+atrav%C3%A9s+da+plataforma+e+gostaria+de+um+diagn%C3%B3stico+gratuito+de+compliance%21+&type=phone_number&app_absent=0"
      imageUrl={Compliance}
      alt="Jurídico Conlicitação - Compliance"
    />
  );

  // Conlicitação Academy em fase alfa: banner só aparece para clientes alfa_testers.
  const academy = profile?.alfa_tester
    ? [<Banner linkUrl="/academy" imageUrl={Academy} alt="Conlicitação Academy" />]
    : [];

  const representantes = panel?.representant_access
    ? [
        <Banner
          linkUrl="https://conlicitacao.com.br/conheca-a-plataforma-de-representantes-de-licitacoes/"
          imageUrl={Representantes}
          alt="Plataforma representantes"
        />,
      ]
    : [];

  const roboLances = panel?.banner_robo_access
    ? [
        <Banner
          linkUrl="/robo_lance"
          imageUrl={BannerRoboLances}
          alt="Robô de Lances - Compras Gov"
        />,
      ]
    : [];

  const newRoboLances = panel?.banner_new_robo_access
    ? [
        <Banner
          linkUrl="https://youtu.be/EGoQbIcDNAs"
          imageUrl={BannerNewRoboLances}
          alt="Novidade no Robô de Lances - Compras Gov"
        />,
      ]
    : [];

  const banners = [
    ...roboLances,
    ...newRoboLances,
    conlicitaseg,
    ...academy,
    compliance,
    ...drLicitaBanner,
    ...representantes,
    defaultIl,
  ];

  const nextSlide = () => {
    setCurrentIndex((prevIndex) => (prevIndex + 1) % banners.length);
  };

  const restartAutoSlide = () => {
    if (autoSlide) clearInterval(autoSlide);

    const newInterval = setInterval(nextSlide, 5000);
    setAutoSlide(newInterval);
  };

  useEffect(() => {
    restartAutoSlide();
    return () => {
      if (autoSlide) clearInterval(autoSlide);
    };
  }, []);

  const handleDotClick = (index: number) => {
    setCurrentIndex(index);
    restartAutoSlide();
  };

  return (
    <Container className="banner-carousel h-100 d-flex flex-column">
      <div className="banner-content">{banners[currentIndex]}</div>
      <div className="dots px-3">
        {banners.map((_, index) => (
          <span
            className={`dot ${index === currentIndex ? 'active' : ''}`}
            onClick={() => handleDotClick(index)}
            key={index}
          />
        ))}
      </div>
    </Container>
  );
};

export default BannerSlideNewPanel;
